import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/AllCourses'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class AllCoursesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "AllCoursesStore",
			variables: false,
		})
	}
}

export async function load_AllCourses(params) {
	await initClient()

	const store = new AllCoursesStore()

	await store.fetch(params)

	return {
		AllCourses: store,
	}
}
